import React, { useContext } from 'react'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'

import { digObject } from '@campaignhub/javascript-utils'
import {
  Box, Button, Image, Link, ModalContext, SidebarModal, Text,
} from '@campaignhub/suit-theme'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLink } from '@fortawesome/pro-light-svg-icons'

import Icons from '@components/Icons'
import PageContext from '@contexts/pageContext'
import decodeBase64Url from '@functions/decodeBase64Url'

const ClientResourceModal = (props) => {
  const { callbacks, modalKey, showModal } = props

  const { serviceJob } = useContext(PageContext)

  const entities = useSelector(reduxState => reduxState.entities)
  const { serviceGroups } = entities

  const { closeModal } = callbacks

  const modalContext = useContext(ModalContext)
  const { modalData } = modalContext

  const resourcePayload = digObject(modalData, modalKey, {})

  const { resource } = resourcePayload

  const isLink = resource?.metadata?.type === 'link'
  const decodedLinkUrl = isLink ? decodeBase64Url(resource?.metadata?.link) : null

  const thumbnailUrl = resource?.content_type?.startsWith('image/') ? resource?.download_uri : resource?.metadata?.thumbnail
  const imageUrl = thumbnailUrl || ''

  return (
    <SidebarModal callbacks={callbacks} modalKey={modalKey} showModal={showModal} size="small">
      <SidebarModal.Header
        callbacks={callbacks}
        title="Client"
        titleSecondLine="Resource"
      />
      <SidebarModal.Content>
        <Box flexDirection="column" marginBottom="small" borderRadius={5}>
          <Link href={isLink ? decodedLinkUrl : resource?.download_uri} target="_blank">
            {isLink ? (
              <Box
                alignItems="center"
                backgroundColor="hoverLightGrey"
                borderRadius={5}
                color="bodyFontColor"
                display="grid"
                height={230}
                justifyContent="center"
                width="100%"
              >
                <FontAwesomeIcon icon={faLink} size="3x" />
              </Box>
            ) : (
              <Image
                backgroundPosition="center top"
                borderRadius={5}
                boxProps={{ backgroundColor: 'hoverLightGrey' }}
                width="100%"
                height={230}
                url={imageUrl}
              >
                {!imageUrl && resource?.content_type === 'application/pdf' && (
                  <Box
                    alignItems="center"
                    color="bodyFontColor"
                    display="grid"
                    justifyContent="center"
                    width="100%"
                  >
                    <Icons name={serviceGroups[serviceJob.serviceGroupId]?.name} size={40} width="100%" />
                  </Box>
                )}
              </Image>
            )}
          </Link>
        </Box>
        <Text color="bodyFontLightColor" fontSize="xsmall" textAlign="center" style={{ width: '100%', wordWrap: 'break-word', overflowWrap: 'break-word' }}>
          {resource?.metadata?.name || resource?.name}
        </Text>
        {isLink && (
          <>
            <Text marginBottom="medium" fontSize="small" marginTop="large">Link:</Text>
            <Link href={decodedLinkUrl} target="_blank" style={{ wordBreak: 'break-all', fontSize: 'small' }}>
              {decodedLinkUrl}
            </Link>
          </>
        )}
        <Text marginBottom="medium" fontSize="small" marginTop="large">{isLink ? 'Link Note:' : 'File Note:'}</Text>
        <Text
          color="bodyFontLightColor"
          marginBottom="small"
          fontSize="small"
          style={{ whiteSpace: 'pre-line' }}
        >
          {resource?.metadata?.notes?.replace(/\\n/g, '\n')}
        </Text>
      </SidebarModal.Content>
      <SidebarModal.Footer>
        <Button
          buttonStyle="secondaryUtility"
          onClick={closeModal}
          size="medium"
        >
          Close
        </Button>
      </SidebarModal.Footer>
    </SidebarModal>
  )
}

ClientResourceModal.propTypes = {
  callbacks: PropTypes.object.isRequired,
  modalKey: PropTypes.string,
  showModal: PropTypes.bool,
}

ClientResourceModal.defaultProps = {
  modalKey: 'ClientResourceModal',
}

const LazyLoadedModal = props => (
  <SidebarModal.RenderController {...props}>
    <ClientResourceModal {...props} />
  </SidebarModal.RenderController>
)

export default LazyLoadedModal
